export const defaultDocument = {
    description: 0,
    type: {
        description: '-'
    }
};

export const defaultTelephone = {
    description: '-'
};

export const defaultEmail = {
    description: '-'
};

export const defaultLevels = {
    description: '-'
};

export const defaultToDelete = {
    accounts: [],
    person: {
        attributes: {
            first_name: {
                value: ''
            },
            last_name: {
                value: ''
            }
        }
    }
};
